import RightSidebar from '../../RightSidebar';
import LeftSidebar from '../../LeftSidebar';
import { Box } from 'foundations-components/transitional/components/Box';
import { ColumnSpreads } from 'foundations-components/transitional/components/ColumnSpreads';
import TopFullWidth from '../../TopFullWidth';
import CollapsibleRightSidebar from './CollapsibleRightSidebar';
import { Flex } from 'foundations-components/components/Flex';
import UniversalSaveBar from 'customer-data-properties/savebar/UniversalSaveBar';
import styled from 'styled-components';
import OverlaysRightSidebar from '../../OverlaysRightSidebar';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// @bend-expect trellis-tokenized
const LeftSidebarWrapper = styled.div.withConfig({
  displayName: "ProfileThreeColumn__LeftSidebarWrapper",
  componentId: "sc-16572we-0"
})(["height:100%;flex-basis:25%;max-width:500px;min-width:280px;background-color:", ";border-right:", ";@media screen and (min-width:1920px){& + div{min-width:968px;}}@media screen and (max-width:1400px){flex-basis:28%;}"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`);

// @bend-expect trellis-tokenized
const RightSidebarWrapper = styled.div.withConfig({
  displayName: "ProfileThreeColumn__RightSidebarWrapper",
  componentId: "sc-16572we-1"
})(["height:100%;background-color:", ";border-left:", ";width:100%;"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`);

// z-index is 1 greater than than the z-index of the floating purple chat/help bubble
const StyledOverlay = styled.div.withConfig({
  displayName: "ProfileThreeColumn__StyledOverlay",
  componentId: "sc-16572we-2"
})(["align-items:flex-end;bottom:0;display:flex;height:0;max-height:100%;overflow:visible;position:absolute;right:calc(100% + 16px);z-index:1016;"]);
const ProfileThreeColumn = ({
  children,
  objectType,
  onCommunicatorClick,
  subject,
  subjectId
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    id: "crm",
    blockSize: "calc(100vh - 44px)",
    backgroundColor: "fill-surface-recessed",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(TopFullWidth, {
        objectType: objectType,
        subjectId: subjectId
      }), /*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(UniversalSaveBar, {})]
    }), /*#__PURE__*/_jsx(ColumnSpreads, {
      expands: true,
      align: "stretch",
      children: /*#__PURE__*/_jsxs(Flex, {
        blockSize: "100%",
        children: [/*#__PURE__*/_jsx(LeftSidebarWrapper, {
          "data-onboarding": "left-sidebar-container",
          "data-selenium-test": "left-sidebar-container",
          children: /*#__PURE__*/_jsx(LeftSidebar, {
            objectType: objectType,
            subjectId: subjectId
          })
        }), /*#__PURE__*/_jsx(Box, {
          shrink: "100000",
          inlineSize: "100%",
          blockSize: "100%",
          minInlineSize: "500px",
          "data-selenium-test": "timeline-wrapper",
          children: children
        }), /*#__PURE__*/_jsx(CollapsibleRightSidebar, {
          "data-test-id": "records-right-sidebar",
          objectType: objectType,
          children: /*#__PURE__*/_jsx(RightSidebarWrapper, {
            "data-selenium-test": "right-sidebar-container",
            children: /*#__PURE__*/_jsx(RightSidebar, {
              objectType: objectType,
              onCommunicatorClick: onCommunicatorClick,
              subjectId: subjectId
            })
          })
        }), /*#__PURE__*/_jsx(StyledOverlay, {
          children: /*#__PURE__*/_jsx(OverlaysRightSidebar, {
            objectType: objectType,
            subject: subject,
            subjectId: subjectId
          })
        })]
      })
    })]
  });
};
export default ProfileThreeColumn;